/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import React, { useEffect } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import './App.css';

import { Consent } from './Consent';
import { Register } from './Register';
import {
  Grid, Container, Paper
} from '@material-ui/core';
import logo from "./Close.jpg";
import UserService from "./services/user.service";
import { useStateIfMounted } from 'use-state-if-mounted';
function App() {
  const [registerStatus, setRegisterStatus] = useStateIfMounted("OFF");
  const [showForm, setShowForm] = useStateIfMounted(false);
  useEffect(async () => {

    let resp = await UserService.getSettings()
  
      setShowForm(true)
      setRegisterStatus(resp.data.registerStatus)
  

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
       {showForm ?
    <React.Fragment>
      
      {registerStatus === "OFF" ?
        <Container component="main" maxWidth="md">
          <Paper style={{ marginTop: 20 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} align="center">
                <img
                  alt=""
                  src={logo}
                  width="80%"


                />
              </Grid>

            </Grid>
          </Paper>
        </Container> :
        <Switch >
          <Route exact path="/" component={Consent} />
          <Route path="/register/:accept" name="Register Page" component={Register} />

          <Redirect from="*" to="/" />
        </Switch>}

    </React.Fragment>:
    null}
    </React.Fragment>
   

  );
}

export default App;
